import * as Config from '../../../config';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { Switch, Route } from "react-router-dom";

import GenresManager from '../genres/GenresManager';
import Playlist from '../playlist/Playlist';
import ArtistLabelV2 from '../views/ArtistLabelV2';
import ListV2 from '../content/list/ListV2';
import Release from '../views/Release';

function ConnectedMainRoute({ width, height }) {
  return (
    <Switch>
      <Route path="/genres">
        <GenresManager hasSideMenu={false} style={{ width }} />
      </Route>
      <Route path="/charts/:id" render={ props =>
        <Playlist path={`/v4/catalog/charts/${props.match.params.id}`} type={`charts`}
          propertyUpdatedDate={`change_date`}
          propertyCreatedDate={`add_date`}
         />
      } />
      <Route path="/releases/:id/:trackid" render={ props =>
        <Release id={props.match.params.id} trackID={props.match.params.trackid} />
      } />
      <Route path="/releases/:id" render={ props =>
        <Release id={props.match.params.id} trackID={null} />
      } />
      <Route path="/top100">
        <ListV2
          title={'Top 100'}
          titleContainerClassName={`title-border-bottom`}
          pathApi={`/v4/catalog/tracks/top/100/?enabled=true&per_page=100`}
          sortable={false}
          id={`top100`}
          width={width}
          height={height - (Config.TAB_BAR_GUTTER * 2.3)}
          size={Config.LIST_ROW_HEIGHT}
          style={{marginTop: 0}}
          filtersStyle={{position: `absolute`, top: 0, right: 125}}
          panelStyle={{ margin: `8px 0px 16px 0px` }}
          isLoadMore={false}
          type={`Full#`}
          orderBy={[`release`, `top`, `title`, `mix_name`, `remixers_s`, `label`, `genre_s`, `key_camelot`, `bpm`, `artists_s`]}
          filters={[`track_name`, `mix_name`, `artists_s`, `remixers_s`, `label`, `genre_s`, `bpm`, `key`]}
          isBoost={true}
          automix={true}
          automixName={`Top 100`}
          automixStyle={{ position: `absolute`, top: 0, left: `auto`, right: 0 }}
          enableShortcuts={true}
          from={`/top100`}
        />
      </Route>
      <Route path="/artists/:slug/:id" render={ props =>
        <ArtistLabelV2
          type={`Artist`}
          pathItem={`/v4/catalog/artists/${props.match.params.id}/`}
          pathReleases={`/v4/catalog/releases/?artist_id=${props.match.params.id}&order_by=-publish_date`}
          pathTop={`/v4/catalog/artists/${props.match.params.id}/top/100`}
          pathTracks={`/v4/catalog/tracks/?artist_id=${props.match.params.id}&per_page=100&order_by=-publish_date`}
          pathCharts={`/v4/catalog/charts/?enabled=true&is_published=true`}
        />
      } />
      <Route path="/labels/:slug/:id" render={ props =>
        <ArtistLabelV2
          type={`Label`}
          pathItem={`/v4/catalog/labels/${props.match.params.id}/`}
          pathReleases={`/v4/catalog/releases/?label_id=${props.match.params.id}&order_by=-publish_date`}
          pathTop={`/v4/catalog/labels/${props.match.params.id}/top/100`}
          pathTracks={`/v4/catalog/tracks/?label_id=${props.match.params.id}&per_page=100&order_by=-publish_date`}
          pathCharts={null}
        />
      } />
    </Switch>
  );
}

ConnectedMainRoute.propTypes = {
  width: PropTypes.any,
  height: PropTypes.any
}

const MainRoute = connect(
  state => ({
    width: state.dimension.width,
    height: state.dimension.height
  })
)(ConnectedMainRoute);

export default MainRoute;
